// ** IMPORTANT **: Keep in sync with functions/src/index.ts BOOK_INVITE_RECIPIENT_ELIGIBILITY_INVALID_ARGUMENT_REASON
export enum BOOK_INVITE_RECIPIENT_ELIGIBILITY_INVALID_ARGUMENT_REASON {
    missingRecipientEmails = 'missingRecipientEmails',
    invalidRecipientEmails = 'invalidRecipientEmails',
    tooManyRecipientEmails = 'tooManyRecipientEmails',
}
